<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop :detailTop="detailTop" />
          <div class="row mb-2">
            <div class="col-md-7 pr-1">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/operasi/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mt-4 mb-2">
            <div class="col-md-6">
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Jadwalkan Operasi
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  to="/operasi"
                >Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset('/operasi')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import Alert from "@/components/Alert.vue";
import {
  resetForms,
  setPatientIntro,
  setRawatIntro,
  getFullUrl,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  dataEdit,
  upperForm,
  leftForm,
  rightForm,
} from "@/data/OperasiForm.js";

export default {
  name: "OperasiForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      slug: "",
      data: dataEdit,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      file_persetujuan_lama: "",
      leftForm,
      rightForm,
      upperForm,
      formSet: {
        tanggal: "",
        sign_in: "",
        id_dokter_operator: "",
        // kategori_tindakan: "",
        // golongan_tindakan: "",
        nama_operasi: "",
        // jenis_anestesi: "",
        generate_form: "",
        file_persetujuan: null,
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      //console.log('masuk handle form');
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      //console.log(valid);
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          //console.log(key+': '+self.formSet[key]);
          if (key != "generate_form") {
            if (self.formSet[key]) {
              if (
                !(
                  key == "file_persetujuan" &&
                  self.formSet[key] == self.file_persetujuan_lama
                )
              ) {
                formData.append(key, self.formSet[key]);
              }
            }
          }
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "operasi/" + this.$route.params.id,
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            setTimeout(function() {
              self.saveSuccess = false;
              self.reset(
                `/operasi/detail/${self.$route.params.id_ralan}/${self.$route.params.id}`
              );
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      //console.log(e);
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      //console.log(this.formSet[e.target.name]);
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.leftForm, this.rightForm, this.upperForm],
        true,
        this.handleChange
      );
      // }
      if (!url) {
        this.$router.go(-1);
      } else {
        ////console.log(url);
        this.$router.push(url);
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              if (column.type == "file" || column.type == "image") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
      this.validated = true;
      return valid;
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi/${this.$route.params.id}`
        );
        //console.log(JSON.stringify(result));
        if (result.status == "200") {
          let self = this;
          //console.log(result.data);
          Object.keys(this.formSet).forEach(function(key) {
            if (key == "file_persetujuan") {
              var url = getFullUrl(
                self.$store.state.baseStorageURL,
                result.data[key]
              );
              self.file_persetujuan_lama = url;
              //console.log(self.file_persetujuan_lama);
              self.formSet[key] = url;
              //console.log(self.formSet[key]);
              //console.log(url);
            } else if (key != "generate_form") {
              self.formSet[key] = result.data[key];
            }
          });
          //console.log(self.formSet);
          this.updateForm();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              (self.formSet[column.name] &&
                self.formSet[column.name] != null &&
                self.formSet[column.name] != "null") ||
              self.formSet[column.name] == 0
            ) {
              if (column.type == "file" || column.type == "image") {
                if (self.formSet[column.name]) {
                  var reader = new FileReader();
                  reader.onload = function(e) {
                    column.value = e.target.result;
                  };
                  reader.readAsDataURL(self.formSet[column.name]);
                }
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
    },
    generateForm() {
      let route = this.$router.resolve({
        path: `/document/${this.slug}/persetujuan`,
      });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, "_blank");
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          let doctors = result.data.data;
          //console.log(doctors);
          this.leftForm[1].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
        // this.fetchNurses();
      } catch (e) {
        //console.log(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    // this.formSet['id_ralan']=this.$route.params.id_ralan;
    //console.log(this.formSet['id_ralan']);
    this.displayData();
    this.fetchDoctors();
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id_ralan}`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.ralan = result.data;
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        this.slug = this.CryptoJS.AES.encrypt(
          JSON.stringify(this.ralan),
          this.$store.state.simrsSecretPassphrase
        )
          .toString()
          .replace(/\//g, "fRWdSl45h");
        this.rightForm[0].columns[0].function = () => this.generateForm();
        this.rightForm[0].columns.splice(0, 1, this.rightForm[0].columns[0]);
        //console.log('ralan');
        // this.formSet['no_rawat']=result.data.no_rawat;
        // this.formSet['darurat']=result.data.no_rawat;
        // this.formSet['no_rm']=result.data.pasien.no_rm;
        // this.formSet['id_dokter']=result.data.id_dokter;
        //console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
  },
};
</script>
